<div class="login">
    <div class="login-left-box"></div>
    <div class="login-right-box">
         <div class="center">
            <div id="sign-in-widget"></div>
        </div>
        <div class="mt-100 action-content1">
            <div class="account-content">Don't have an account? <a href="{{ environment?.userAccessRequestURL }}">Sign Up</a></div>

            <p>© 2001 - 2025 Chevron U.S.A. Inc. All rights reserved.</p>

            <div>
                <a target="_blank" href="http://www.chevron.com/termsofuse/">Terms of Use</a>
                &nbsp; | &nbsp;
                <a target="_blank" href="http://www.chevronlubricants.com/en_US/privacystatement.html">Privacy
                    Statement</a>
            </div>
        </div>
    </div>
</div>